import React from 'react';
import PropTypes from 'prop-types';

const defaultError = <span><strong>There was a problem submitting the form</strong> please address the flagged errors and try again</span>;

const ValidationError = ({ error }) => {
  error = error || defaultError;
  return <div className="alert alert-danger">{error}</div>;
};

ValidationError.propTypes = {
  error: PropTypes.object
};

export default ValidationError;